import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SELLER_DETAILS_ROUTE } from '../shared/constants/routes';
import { AuthGuard } from '../guards/auth.guard';
import { SellerDetailsComponent } from './seller-details/seller-details.component';

const routes: Routes = [
  {
    path: `${SELLER_DETAILS_ROUTE}/:seller_id`,
    component: SellerDetailsComponent,
    canActivate: [AuthGuard],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class SellerDetailsRoutingModule {}
